export default __webpack_public_path__ + "static/media/download.d765fe5b.svg";